export default {
  title: "Destek",
  rules: {
    note: "Talep göndermeden önce lütfen kuralları inceleyin:",
    rule_1: "1. Öncelikle {faq} (SSS) bölümünü inceleyin — yanıt zaten orada olabilir.",
    rule_2: "2. Ödeme sorunlarında mutlaka işlem detaylarını ekleyin (tarih, tutar, ödeme yöntemi, ekran görüntüleri).",
    rule_3: "3. Dosya indirme sorunlarında mutlaka bu dosyaların bağlantılarını belirtin.",
    rule_4: "4. Telif hakkı veya kuralları ihlal eden diğer dosyalarla ilgili konularda şu adrese yazın: {email}",
    rule_5: "5. İş birliği, ortaklık programları, reklam ve diğer iş teklifleri için şu adrese yazın: {email}",
    rule_6: "6. Yanıt süresi, talebin karmaşıklığına ve destek yoğunluğuna bağlı olarak 12 saat ile 2 iş günü arasında değişebilir.",
    rules: "kurallar",
    faq: "sıkça sorulan sorular"
  },
  messages: {
    note: "*Son {count} mesaj görüntüleniyor",
    you: "Siz",
    support: "Destek",
    autoanswer_subject_is_over: "Sorununuz çözüldüğü için görüşme kapatılmıştır.\nDestek ekibine başvurduğunuz için teşekkür ederiz."
  },
  inputs: {
    message: {
      placeholder: "Sorunuzu yazın"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Dosya ekle",
      attached_files: "Ekli dosyalar:"
    }
  },
  errors: {
    generic: "Hata",
    invalid_file_type: "Desteklenmeyen dosya biçimi.",
    max_file_size_limit: "Dosya çok büyük. Daha küçük bir dosya seçin.",
    filename_too_long: "Dosya adı çok uzun",
    filename_invalid_chars: "Dosya adı geçersiz karakterler içeriyor"
  },
  btn: {
    send: "Gönder"
  }
};
